import { render, staticRenderFns } from "./LeitorList.vue?vue&type=template&id=1bceabfa"
import script from "./LeitorList.vue?vue&type=script&lang=js"
export * from "./LeitorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports